'use strict';

/* eslint no-undef: "off" */
/**
 * timer
 */
define('timer',['countDownTimer', 'GAReport'], function (Timer, GAReport) {
  return {
    template: '\n      <a class="in-timer-img" :href="productInfo.url">\n        <div class="in-timer-container">\n          <div class="in-timer" :style="{backgroundImage: \'url(\'+ productInfo.banner +\')\'}">\n            <div class="in-timer-content in-container" :class="{\n              \'in-timer-center\': productInfo.content_location === \'center\',\n              \'in-timer-left\': productInfo.content_location === \'left\',\n              \'in-timer-right\': productInfo.content_location === \'right\'\n            }">\n              <div>\n                <ul>\n                  <li>\n                    <span class="in-time-d font-medium" v-text="date.d"></span>\n                    <span class="in-time-subtitle" v-text="i18n.days"></span>\n                  </li>\n                  <li class="in-time-split">:</li>\n                  <li>\n                    <span class="in-time-h font-medium" v-text="date.h"></span>\n                    <span class="in-time-subtitle" v-text="i18n.hours"></span>\n                  </li>\n                  <li class="in-time-split">:</li>\n                  <li>\n                    <span class="in-time-m font-medium" v-text="date.m"></span>\n                    <span class="in-time-subtitle" v-text="i18n.mins"></span>\n                  </li>\n                  <li class="in-time-split">:</li>\n                  <li>\n                    <span class="in-time-s font-medium" v-text="date.s"></span>\n                    <span class="in-time-subtitle" v-text="i18n.secs"></span>\n                  </li>\n                </ul>\n                <p class="in-timer-content_title" v-text="productInfo.content_title"></p>\n                <p v-if="productInfo.content_desc" class="in-timer-content_desc" v-text="productInfo.content_desc"></p>\n                <div class="in-timer-price">\n                  <p class="in-timer-special-price font-medium" v-html="productInfo.special_price" v-if="productInfo.special_price"></p>\n                  <p class="in-timer-orinal-price" v-html="productInfo.orinal_price" v-if="productInfo.special_price && productInfo.orinal_price" :class="isSpecialPrice"></p>\n                </div>\n                <a class="in-btn-group" :href="productInfo.url" @click="onPromotionClicked(productInfo)">\n                  <span v-text="i18n.shopNow"></span>\n                </a>\n              </div>\n            </div>\n          </div>\n        </div>\n      </a>\n    ',
    data: function data() {
      return {
        i18n: {
          days: 'Days',
          hours: 'Hours',
          mins: 'Mins',
          secs: 'Secs',
          shopNow: 'SHOP NOW'
        },
        date: {
          d: '00',
          h: '00',
          m: '00',
          s: '00'
        },
        currentTime: '',
        endTime: '',
        timerObj: {}
      };
    },

    props: {
      'productInfo': {
        type: Object,
        default: {},
        required: true
      }
    },
    computed: {
      isSpecialPrice: function isSpecialPrice() {
        return {
          'is-special-price': Boolean(this.productInfo.special_price)
        };
      }
    },
    methods: {
      countdown: function countdown() {
        var _this = this;

        setTimeout(function () {
          _this.timerObj.run().then(function (timer) {
            if (timer.runTimer) {
              _this.date.d = timer.d;
              _this.date.h = timer.h;
              _this.date.m = timer.m;
              _this.date.s = timer.s;
              _this.countdown();
            }
          });
        }, 1000);
      },
      reportGAPromotionView: function reportGAPromotionView(data) {
        if (!data.id || !data.name) {
          return;
        }
        var promotions = [{
          'id': data.id || "",
          'name': data.name,
          'creative': "",
          'position': 1,
          'url': data.url
        }];

        new GAReport().promotionView({
          'eventAction': 'HOME_BANNER',
          'eventCategory': 'HOME_BANNER_#VERSION#',
          'promotions': promotions
        });
      },
      onPromotionClicked: function onPromotionClicked(data) {
        if (!data.id || !data.name) {
          return;
        }
        var promotions = [{
          'id': data.id || "",
          'name': data.name,
          'creative': "",
          'position': 1,
          'url': data.url
        }];
        new GAReport().promotionClick({
          'eventAction': 'HOME_BANNER_' + data.name,
          'eventCategory': 'HOME_BANNER_#VERSION#',
          'promotions': promotions
        });
      }
    },
    mounted: function mounted() {
      this.currentTime = this.productInfo.now * 1000;
      this.endTime = this.productInfo.expired_at * 1000;
      this.timerObj = new Timer(this.currentTime, this.endTime);
      this.countdown();

      this.reportGAPromotionView(this.productInfo);
    }
  };
});
